import React, { Component } from 'react';
import { css } from 'emotion';

import Tooltip from '../../../../../common/components/core/Tooltip';
import Input from '../../../../../common/components/core/Input';
import StatusLabel from '../../../../../common/components/core/StatusLabel';
import DiscoAdsAppIconWrapper from './../DiscoAdsAppIconWrapper';

import { truncate } from '../../../../support/utils';
import { getIntentStatusLabelProps } from '../../discoAdsUtils';

import {
  DA_INTENT_NAME_CHAR_LIMIT,
  INTENT_SEARCH_RESULTS,
  SELECTED_INTENTS
} from '../../discoAdsConstants';

import Colors from '../../../../../../styles/Colors';

const staticStyles = {
  row: css({
    display: 'flex'
  }),
  appIconAndNameContainer: css({
    display: 'flex',
    alignItems: 'center'
  }),
  intentName: css({
    fontSize: '14px',
    color: Colors['@tundora'],
    marginLeft: '5px'
  }),
  statusLabelContainer: css({
    display: 'flex',
    alignItems: 'center',
    marginRight: '20px',
    width: '60px'
  }),
  bidInputContainer: css({
    marginRight: '9px'
  }),
  removeIcon: css({
    fontFamily: 'Material Icons',
    fontSize: '18px',
    color: Colors['@java'],
    cursor: 'pointer',
    marginBottom: '10px',
    alignSelf: 'center'
  })
};

const intentIconStyles = {
  iconContainer: css({
    marginLeft: '5px'
  }),
  icon: css({
    height: '25px',
    width: '24px',
    borderRadius: '4px'
  })
};

class DiscoAdsIntentListItem extends Component {
  _handleBidChange = e => {
    const { value: bid } = e.target;
    const { intent, onIntentBidChange } = this.props;
    onIntentBidChange({ intentId: intent.id, bid });
  };

  _renderIntentCopy = () => {
    const { searchLimit, selectedLimit } = DA_INTENT_NAME_CHAR_LIMIT;
    const {
      intent: { pretty_name },
      type
    } = this.props;
    const charLimit =
      type === INTENT_SEARCH_RESULTS ? searchLimit : selectedLimit;
    return pretty_name.length > charLimit ? (
      <Tooltip body={pretty_name} children={truncate(pretty_name, charLimit)} />
    ) : (
      pretty_name
    );
  };

  render() {
    const dynamicStyles = {
      intentContainer: css({
        height: '35px',
        borderRadius: '5px',
        backgroundColor: Colors['@white-lilac'],
        marginBottom: '5px',
        display: 'flex',
        flex: 1,
        alignItems: 'center',
        justifyContent: 'space-between',
        marginRight: `${this.props.type === SELECTED_INTENTS ? '9px' : null}`,
        cursor: `${
          this.props.type === INTENT_SEARCH_RESULTS ? 'pointer' : null
        }`
      }),
      bidInput: css({
        height: '35px',
        width: '88px',
        border: `1px solid`,
        borderColor: `${
          this.props.intent.bidIsValid
            ? Colors['@gallery']
            : Colors['@persion-red']
        }`,
        borderRadius: '6px'
      })
    };
    const {
      row,
      intentContainer,
      intentName,
      appIconAndNameContainer,
      statusLabelContainer,
      bidInputContainer,
      removeIcon,
      bidInput
    } = Object.assign({}, staticStyles, dynamicStyles);
    const {
      intent,
      rowIndex,
      type,
      onSearchResultClick,
      onRemoveIntentFromSelected
    } = this.props;
    return (
      <div className={row}>
        <div
          className={intentContainer}
          onClick={() => onSearchResultClick && onSearchResultClick(intent.id)}
          data-testid={`intent-search-result-${rowIndex}`}
        >
          <div className={appIconAndNameContainer}>
            <DiscoAdsAppIconWrapper
              url={intent.img_url}
              styles={intentIconStyles}
            />
            <div className={intentName}>{this._renderIntentCopy()}</div>
          </div>
          {type === INTENT_SEARCH_RESULTS && (
            <div className={statusLabelContainer}>
              <StatusLabel {...getIntentStatusLabelProps(intent.popularity)} />
            </div>
          )}
        </div>
        {type === SELECTED_INTENTS && (
          <Input
            testid="da-selected-intent-bid"
            value={intent.max_cpc}
            i13nLabel="Disco Ads - selected intent"
            className={bidInputContainer}
            inputClassName={bidInput}
            onChange={this._handleBidChange}
          />
        )}
        {type === SELECTED_INTENTS && (
          <span
            className={removeIcon}
            onClick={() => onRemoveIntentFromSelected(intent.id)}
          >
            remove_circle_outline
          </span>
        )}
      </div>
    );
  }
}

export default DiscoAdsIntentListItem;
